import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceQueryOptions } from './useInvoice';

export const useDeleteInvoice = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/invoices/draft/${id}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.removeQueries(invoiceQueryOptions(id));

      return queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.index.root });
    },
  });
};
